const uri = 'data:application/vnd.ms-excel;base64,';

function base64(s) {
  return window.btoa(unescape(encodeURIComponent(s)));
}

function format(s, c) {
  return s.replace(/{(\w+)}/g, (m, p) => c[p]);
}

function checkDomAccess() {
  if (!document) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Failed to access document object');
    }
    return null;
  }
}

function checkHtmlTable(tableId) {
  if (document.getElementById(tableId).nodeType !== 1 || document.getElementById(tableId).nodeName !== 'TABLE') {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Provided table property is not html table element');
    }
    return null;
  }
}

function exportOnI11(table, filename) {
  // If IE11
  if (window.navigator.msSaveOrOpenBlob) {
    const fileData = [`${
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-mic' +
      'rosoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta cha' +
      'rset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:Exce' +
      'lWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/>' +
      '</x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></' +
      'xml><![endif]--></head><body>'}${table}</body></html>`,
    ];
    const blobObject = new Blob(fileData);
    document.getElementById('react-html-table-to-excel').click()(() => {
      window.navigator.msSaveOrOpenBlob(blobObject, filename);
    });

    return true;
  }
}

export function reactHtmlTableToExcel(tableId, sheetName, fileName) {
  checkDomAccess();
  checkHtmlTable(tableId);

  const table = document.getElementById(tableId).outerHTML;
  const sheet = String(sheetName);
  const filename = `${String(fileName)}.xls`;

  const template =
    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-mic' +
    'rosoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta cha' +
    'rset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:Exce' +
    'lWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/>' +
    '</x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></' +
    'xml><![endif]--></head><body>{table}</body></html>';

  exportOnI11();

  const context = {
    'worksheet': sheet || 'Worksheet',
    table,
  };

  const element = window.document.createElement('a');
  element.href = uri + base64(format(template, context));
  element.download = filename;
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);

  return true;
}
